import { useEffect } from "react";
import heroBanner from "../../assets/images/pages/classes-de-manejo.jpg";
import handbookEn from "../../assets/images/florida-driver-license-handbook.png";
import handbookEs from "../../assets/images/florida-driver-license-handbook-es.png";

import ShellCard from "../../components/ShellCard.jsx";

const ClasesDeManejoDetails = () => {
    useEffect(() => {
        document.title = "Detalles de Clases de Manejo - Metro Traffic School";
    }, []);

    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        background: `url(${heroBanner})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">
                                Aprende a manejar con Metro Traffic School!
                            </h1>
                            <p className="banner-subheading">1-888-41-METRO</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container py-5">
                <div className="row">
                    <div className="col-12">
                        <ShellCard>
                            <h3
                                className="fw-bold mb-3"
                                style={{ color: "var(--metro-yellow)" }}
                            >
                                Tenemos Programas de Manejo que se Acomodan a lo que Usted Necesita
                            </h3>
                            <p className="mb-2 text-white">CLASES DE CONDUCCIÓN</p>
                            <ul className="mb-4 text-white">
                                <li>Clases Individuales duran una hora y media</li>
                                <li>
                                    Inscríbase para una sola clase, o ahorre su dinero con el
                                    paquete especial de 2 a 12 horas.
                                </li>
                                <li>
                                    Nuestra escuela de conducción está hecha para aquellas personas
                                    que están aprendiendo a manejar o que simplemente necesitan
                                    actualizarse.
                                </li>
                                <li>
                                    Todas nuestras clases son impartidas por instructores
                                    certificados por el estado en vehículos de control dual.
                                </li>
                                <li>
                                    Nosotros lo recogemos de su casa, oficina o escuela. Nuestras
                                    clases están disponibles en South Florida.
                                </li>
                            </ul>
                            <a
                                href="/clases-de-manejo"
                                className="btn metro-btn-primary fw-bold px-4 py-2 mb-5"
                            >
                                Registrese Ahora!
                            </a>

                            <div className="mb-5">
                                <h5 className="fw-bold mb-2" style={{ color: "var(--metro-yellow)" }}>
                                    Miami-Dade - 305-553-5000
                                </h5>
                                <p className="mb-3 text-white">
                                    De acuerdo al artículo “Las peores 10 ciudades para los
                                    Conductores (2012)”, 2 de estas 10 ciudades se encuentran en el
                                    Condado de Miami-Dade: Miami y Hialeah. Es un 58.4% que esté
                                    involucrado en un accidente en la ciudad de Miami, Florida y un
                                    77.6% en la ciudad de Hialeah.
                                </p>
                                <p className="mb-3 text-white">
                                    Dado a estas desfavorables estadísticas, tenemos instructores
                                    certificados por el estado de la Florida que se especializan en
                                    la práctica de conducir a la defensiva. Nuestras clases de
                                    manejo les beneficiaran tanto a usted como al condado de
                                    Miami-Dade, sea la razón que sea por la que está tomando estas
                                    clases. Empezamos por lo más fundamental, enfatizando en las
                                    reglas y regulaciones de la carretera. De ahí en adelante
                                    trabajamos para prepararte para el examen de conducción.
                                </p>
                                <p className="text-white">
                                    Ya sea que necesite actualizarse o enfocarse en ciertas áreas,
                                    ¡nuestras clases de manejo en Miami le vendrán muy bien! ¡Estas
                                    clases lo prepararan para el examen de manejo más difícil, Miami
                                    y Hialeah!
                                </p>
                            </div>

                            <div className="mb-5">
                                <h5 className="fw-bold mb-2" style={{ color: "var(--metro-yellow)" }}>
                                    Broward - 954-922-3000
                                </h5>
                                <p className="mb-3 text-white">
                                    Si usted se encuentra dentro del área del Condado Broward en la
                                    Florida, usted es elegible para nuestras clases de manejo. Le
                                    enseñaremos como manejar empezando por los aspectos
                                    fundamentales y de ahí ir trabajando para la preparación del
                                    examen práctico.
                                </p>
                                <p className="text-white">
                                    Si usted ya sabe como conducir pero necesita refrescar sus
                                    habilidades de manejo, o incluso si necesita enfatizar en un
                                    área específica ¡estamos a su servicio!
                                </p>
                            </div>

                            <div className="mb-5">
                                <h5 className="fw-bold mb-2" style={{ color: "var(--metro-yellow)" }}>
                                    Palm Beach - 561-963-7555
                                </h5>
                                <p className="mb-3 text-white">
                                    Si usted se encuentra dentro del área del Condado Palm Beach en
                                    la Florida, nosotros nos enfocamos en las reglas y regulaciones
                                    de la carretera. Garantizando así, que usted no solamente
                                    aprenda a manejar; sino, que aprenda a manejar correctamente y
                                    obedeciendo las reglas.
                                </p>
                                <p className="text-white">
                                    Si usted ya sabe manejar pero ha pasado un tiempo o simplemente
                                    quiere mejorar sus habilidades de conducción en ciertas áreas,
                                    podemos acomodarnos a sus solicitudes y llevarlo(a) al nivel de
                                    manejo que usted quiera alcanzar.
                                </p>
                            </div>
                        </ShellCard>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12 d-flex flex-column align-items-start">
                        <div className="d-flex justify-content-start gap-5 flex-wrap">
                            <a
                                href="https://www.flhsmv.gov/pdf/handbooks/englishdriverhandbook.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={handbookEn}
                                    alt="Florida Driver License Handbook"
                                    className="img-fluid"
                                    style={{ maxWidth: "250px" }}
                                />
                            </a>
                            <a
                                href="https://www.flhsmv.gov/pdf/handbooks/spanishdriverhandbook.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={handbookEs}
                                    alt="Manual Oficial Para Licencias de Conducir de Florida"
                                    className="img-fluid"
                                    style={{ maxWidth: "250px" }}
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container py-4">
                <div className="row">
                    <div className="col-12 text-center py-4 rounded shadow-sm">
                        <p className="fw-bold fs-5 text-white mb-3">Llame <a href="tel:1-888-41-METRO" className="text-decoration-none text-white">(1-888-41-METRO)</a> para más información.</p>
                        <a href="/clases-de-manejo" className="btn metro-btn-primary fw-bold px-4 py-2">
                            Registrese Ahora!
                        </a>
                    </div>
                </div>
            </section>


            <div className="container" style={{ marginBottom: "32px" }}>
                <div className="row text-white">
                    <p>
                        Superb Customer Service
                    </p>
                    <p>
                        At Metro we always aim to provide an exceptional and pain free educational experience. We do this by only offering state approved courses that use cutting edge technology and always providing first rate customer service. Here are some reviews left by past clients!
                    </p>
                </div>
            </div>
        </>
    );
};

export default ClasesDeManejoDetails;
